import React from "react";
import { RichText } from "prismic-reactjs";

export default class ProjectItem extends React.Component {
  render() {
    const item = this.props.item;

    return (
      <div className="project-item">
        <a href={this.props.prismicCtx.linkResolver(item)}>
          <img
            src={item.data.main_image.url}
            className="card-img-top mb-2"
            alt="project-card"
          />

          <p className="px-2 text-blue text-uppercase font-weight-bold">
            {RichText.asText(item.data.title)}
          </p>
        </a>

        {item.data.short_description && (
          <p className="px-2">{RichText.asText(item.data.short_description)}</p>
        )}


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectItem.js